<template>
  <div class="layout_header">
    <el-row>
      <el-col :span="24">
        <template v-if="this.$store.state.isComputer">
          <img src="@/assets/image/logo.png" style="height: 36px;margin-top: 12px" class="layout_header_left">
          <span class="layout_header_left" style="margin-left: 100px;font-size: 13px;font-weight:bold;color:white;font-family: fzlt_xh">给世界带来美妙而健康的香气体验</span>
        </template>
          <el-menu
            class="el-menu-demo layout_header_right"
            mode="horizontal"
            background-color="#80bc04"
            text-color="#fff"
            active-text-color="#fff">
          <el-submenu index="1">
            <template slot="title"><img src="@/assets/image/user.png" style="height: 30px;width: 30px;margin-right: 8px">{{ $store.getters.getUser.truename }}</template>
            <el-menu-item index="1-1" @click="dialogFormVisible = true">修改密码</el-menu-item>
            <el-menu-item index="1-2" @click="logout">退出</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-col>
    </el-row>

    <el-dialog :fullscreen="!this.$store.state.isComputer" title="密码修改" :visible.sync="dialogFormVisible">
      <el-form :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="原密码" :label-width="formLabelWidth" prop="password">
          <el-input type="password" v-model="editForm.password" autocomplete="new-password" class="item_width"></el-input>
        </el-form-item>
        <el-form-item label="新密码" :label-width="formLabelWidth" prop="newPwd">
          <el-input type="password" v-model="editForm.newPwd" autocomplete="new-password" class="item_width"></el-input>
        </el-form-item>
        <el-form-item label="新密码确认" :label-width="formLabelWidth" prop="newPwdCheck">
          <el-input type="password" v-model="editForm.newPwdCheck" autocomplete="new-password" class="item_width"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="changePassword">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Header",
  data(){
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.editForm.newPwdCheck !== '') {
          this.$refs.editForm.validateField('newPwdCheck');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.editForm.newPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return{
      editForm:{
        id:this.$store.getters.getUser.id,
        password:'',
        newPwd:'',
        newPwdCheck:''
      },
      dialogFormVisible:false,
      formLabelWidth: '120px',
      rules: {
        password: [
          {  required:true,message:'必填项不能为空', trigger: 'blur' }
        ],
        newPwd: [
          { required:true,validator: validatePass, trigger: 'blur' }
        ],
        newPwdCheck: [
          { required:true,validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    logout() {
      const _this = this
      _this.$axios.get("/logout").then(res => {
        _this.$store.commit("REMOVE_INFO")
        _this.$router.push("/login")

      })
    },
    changePassword(){
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          const _this = this;
          this.$axios.post('/user/changePassword', this.editForm).then(res => {
            _this.$alert('操作成功,跳转到登录界面', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.logout()
              }
            });
          })
        }
      })
    },
    stretch() {
      this.$store.commit("CHANGE_MENU_COLLAPSE");
    }
  }
}
</script>

<style scoped>
.layout_header_right{
  float: right;
}
.layout_header_left{
  float: left;
  font-size: 25px;
}
.el-menu.el-menu--horizontal{
  border-bottom: 0px;
}

/deep/ .el-submenu__title i{
  color: #fff;
}
</style>